import type { Source } from '@/types';

export type SourceTableData = Source;

export type SourceType = 'document' | 'website' | 'api' | 'database' | 'file' | 'custom';

export type SourceFilterType = 'all' | 'LINK' | 'ARTICLE' | 'FILE' | 'INTEGRATION';

export interface SourceFilter {
  label: string;
  value: SourceFilterType;
}

export function getFileExtension(source: Source): string {
  const fileName = (source.metadata?.['fileName'] as string | undefined) ?? source.value;
  return fileName.split('.').pop()?.toLowerCase() ?? '';
}
